import { render, staticRenderFns } from "./InfoCard2.vue?vue&type=template&id=5acb4fc9&scoped=true&"
import script from "./InfoCard2.vue?vue&type=script&lang=ts&"
export * from "./InfoCard2.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCard2.vue?vue&type=style&index=0&id=5acb4fc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb4fc9",
  null
  
)

export default component.exports